var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafari = function SvgSafari(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.899 8.377a1.098 1.098 0 1 1-2.196 0 1.098 1.098 0 0 1 2.196 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.834 3.646a3.76 3.76 0 0 0-3.76 3.76v5.053a1 1 0 0 0 0 .178v1.887a.537.537 0 1 1-1.074 0v-.22a1 1 0 1 0-2 0v.22a2.537 2.537 0 1 0 5.073 0v-.976h1.732v5.623a1 1 0 0 0 1 1h3.293a1 1 0 0 0 1-1v-2.81c0-.584.49-1.057 1.195-1.057s1.195.473 1.195 1.057v2.81a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1V7.406a3.76 3.76 0 0 0-3.76-3.76zm4.138 2H8.834a1.76 1.76 0 0 0-1.76 1.76v4.142h4.137a1.76 1.76 0 0 0 1.76-1.76zm-2.167 7.902h.406a3.76 3.76 0 0 0 3.76-3.76V5.645h3.268c.973 0 1.761.788 1.761 1.76v10.765h-1.512v-1.81c0-1.928-1.64-3.057-3.195-3.057s-3.195 1.13-3.195 3.057v1.81h-1.293z",
    clipRule: "evenodd"
  })));
};
export default SvgSafari;